import React, { useEffect, useRef, useState } from 'react';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
import { useHistory } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import * as action from '../Store/Pom.action';
import { useGradingGroupState } from './GradingGroupProvider';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { treadFile, customStylesGradingFilter } from '../../../../Components/helper';
import ImportModal from './ImportModal';
import ErrorLogModal from './ErrorLogModal';
import ConfirmationModalForUpload from './modalForDownload';
import DragDrogRearrange from '../../../../Components/DragDrogRearrange/DragDrogRearrange';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';

const AsyncTypeahead = asyncContainer(Typeahead);

export const SelectBoxStyles = {
  option: (provided, state) => ({
    ...provided,
    padding: '5px 10px',
  }),
  control: () => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderBottom: '1px solid #848484',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
  menu: (provided, state) => ({
    ...provided,
    margin: '-1px 0 0 0',
    border: '1px solid #848484',
    borderRadius: 0,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: 0,
    color: '#555',
    fontSize: 14,
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: '#848484',
    fontSize: 14,
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: 'none',
  }),
};

function PomLibraryTable() {
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    uploadModal: false,
    AddToThePomLibrary: false,
    updateDescription: false,
    isChecked: false,
    uploadData: {},
    dropDownOption: [],
    OpenReArrange: false,
    rearrangeData: [],
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const history = useHistory();

  const [selectDrop, setSelectDrop] = useState({
    value: 'Library',
    label: 'Library',
  });
  const dropDownOptions = [
    {
      value: 'Library',
      label: (
        <CustomTooltip placement="right" tooltipText={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.LIBRARY')}>
          <i className="icon-Library-1 library-icon-css f-24" />
        </CustomTooltip>
      ),
    },
    {
      value: 'Group',
      label: (
        <CustomTooltip placement="right" tooltipText={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.GROUP')}>
          <i className="icon-Product-Group library-icon-css f-24" />
        </CustomTooltip>
      ),
    },
  ];

  const [suggestionLoader, setsuggestionLoader] = useState(false);
  const dispatch = useDispatch();
  const docRef = useRef(null);
  const typeaheadConfig = useRef(null);
  const { gradingGroupState, setgradingGroup, loggedInUserId, UnitOfMeasure, GradingDeleteAccess, id, GradingAddEditAccess, updateReArrangeSequence, removePomsFromGroup } =
    useGradingGroupState();

  useEffect(() => {
    const isActiveTrueValues = UnitOfMeasure.filter((item) => item.isActive === true);
    setState((prev) => ({
      ...prev,
      dropDownOption: isActiveTrueValues,
    }));
  }, [UnitOfMeasure]);

  const onAddGradingLibrary = async (selected) => {
    const pomData = cloneDeep(gradingGroupState?.pomTableData);
    const data = selected[0];
    if (!data?.code || !String(data.code).trim()) {
      toasterMsg(t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.POM_CODE_REQUIRED'), 'danger');
      typeaheadConfig.current.clear();
      return;
    }
    const isAlreadyInArray = pomData?.some((item) => item?.code === selected[0]?.code);
    if (isAlreadyInArray) {
      toasterMsg(t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.SELECTED_POM_BEEN_ADDED'), 'danger');
    } else {
      const addGrading = gradingGroupState?.sizeRangesForHeader?.map((item) => ({
        ...item,
        grading: 0,
      }));
      data.gradings = addGrading;
      data.tolPlus = 0;
      data.tolMinus = 0;
      pomData.push(data);
      setgradingGroup((prev) => ({
        ...prev,
        pomTableData: pomData,
      }));
    }
    typeaheadConfig.current.clear();
  };

  const onAddGradingFromLibrary = async (selected) => {
    let pomData = cloneDeep(gradingGroupState?.pomTableData);
    const existingCodes = new Set(pomData.map((item) => item?.code));
    const duplicatePoms = selected[0]?.pomLibraries.filter((item) => existingCodes.has(item.code));
    const notMatchingObjects = selected[0]?.pomLibraries.filter((item) => !existingCodes.has(item.code));

    if (duplicatePoms?.length) {
      const pomCodes = duplicatePoms.map((pom) => pom.code);
      const pomCodesString = pomCodes.join(', ');
      toasterMsg(`${pomCodesString} ${t('POM_GROUP.POM_EXIST')}`, 'danger');
    }
    if (notMatchingObjects?.length) {
      const validPoms = notMatchingObjects.filter((item) => item?.code && String(item.code).trim());
      const invalidPoms = notMatchingObjects.filter((item) => !item?.code || !String(item.code).trim());

      if (invalidPoms?.length) {
        toasterMsg(t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.POM_CODE_REQUIRED'), 'danger');
      }

      if (validPoms?.length) {
        const addGrading = gradingGroupState?.sizeRangesForHeader?.map((item) => ({
          ...item,
          grading: 0,
        }));

        const updatedPomLibraries = validPoms.map((library) => {
          const data = { ...library };
          data.gradings = addGrading;
          data.tolPlus = 0;
          data.tolMinus = 0;
          return data;
        });
        pomData = [...pomData, ...updatedPomLibraries];
        setgradingGroup((prev) => ({
          ...prev,
          pomTableData: pomData,
        }));
      }
    }
    typeaheadConfig.current.clear();
  };

  const [showMultiDeleteConfirm, setShowMultiDeleteConfirm] = useState(false);

  /**
   * Opens the confirm step. The delete is persisted immediately on confirm, so
   * it is not undoable by simply leaving the page without saving.
   */
  const handleMultiDelete = () => {
    setShowMultiDeleteConfirm(true);
  };

  const closeMultiDeleteConfirm = () => {
    setShowMultiDeleteConfirm(false);
  };

  const confirmMultiDelete = async () => {
    const selectedIds = [...(gradingGroupState?.selectedPOM || [])];
    setShowMultiDeleteConfirm(false);
    await removePomsFromGroup(selectedIds);
  };

  const handleSelectedSize = (selected) => {
    setgradingGroup((prev) => ({
      ...prev,
      conversationType: selected.name,
      conversionTypeId: selected._id,
    }));
  };

  const downloadSampleFile = async () => {
    const data = {
      type: 'grading',
      sizeRange: gradingGroupState?.sizeRanges,
      name: gradingGroupState?.groupName || '',
    };
    await dispatch(action.downloadGradingSampleFile(data));
  };

  const uploadPomXlsx = async () => {
    setgradingGroup((prevState) => ({
      ...prevState,
      importModal: true,
    }));
  };

  const closeUploadModal = () => {
    setgradingGroup((prevState) => ({
      ...prevState,
      importModal: false,
    }));
  };

  const handleCloseError = () => {
    setgradingGroup((prevState) => ({
      ...prevState,
      errorLog: [],
      isErrorShow: false,
    }));
  };

  const hasDuplicatePOMCode = (data) => {
    const pomCodeMap = data.reduce((acc, item) => {
      const pomCode = item['POM Code*'];
      if (pomCode !== undefined && pomCode !== '--' && pomCode !== null) {
        acc[pomCode] = acc[pomCode] ? [...acc[pomCode], item] : [item];
      }

      return acc;
    }, {});
    console.log('pomCodeMap', pomCodeMap);
    return Object.entries(pomCodeMap).filter(([pomCode, items]) => items.length > 1);
  };

  const uploadExcelDocument = async (value) => {
    const obj = {
      ...state?.uploadData,
      AddToThePomLibrary: value,
      updateDescription: !!state?.isChecked,
    };
    const res = await dispatch(action.uploadPOMXlsxFile(obj, t));
    if (res?.code === 200) {
      closeUploadModal();
      setState((prev) => ({
        ...prev,
        AddToThePomLibrary: false,
        updateDescription: false,
        isChecked: false,
        uploadData: {},
      }));
    }
    if (res?.code === 200 && res?.data?.existPomCode?.length > 0) {
      setgradingGroup((prevState) => ({
        ...prevState,
        errorLog: res?.data?.existPomCode,
        isErrorShow: true,
      }));
    }
  };

  const addDocument = async () => {
    if (docRef?.current) {
      const uploadedDoc = await docRef.current.selectedDocument();
      if (uploadedDoc) {
        const file = uploadedDoc.document;
        const convertedXlsxToArray = await treadFile(file, true);
        const finalPomData = convertedXlsxToArray?.data?.filter((obj) => !Object.values(obj).every((value) => value === '--'));
        const sizes = gradingGroupState?.sizeRangesForHeader?.map((item) => item?.sizeName);
        if (sizes?.every((item) => convertedXlsxToArray?.headerKeys?.includes(item))) {
          const obj = {
            module: 'Grading',
            isUpdate: true,
            graddingsId: id,
            xlsxData: finalPomData,
            headers: convertedXlsxToArray?.headerKeys,
            sizeheaders: gradingGroupState?.sizeRangesForHeader,
            pomTableData: gradingGroupState?.pomTableData,
            result: 'yes',
            file: uploadedDoc?.document,
          };
          const checkDuplicatePomCode = hasDuplicatePOMCode(obj.xlsxData);
          if (checkDuplicatePomCode.length > 0) {
            const array = [];
            checkDuplicatePomCode.forEach((item) => {
              array.push({ code: item[0], message: t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.DUPLICATE_CODE_FOUND') });
            });
            setgradingGroup((prevState) => ({
              ...prevState,
              errorLog: array,
              isErrorShow: true,
            }));
          } else {
            setState((prev) => {
              return {
                ...prev,
                uploadModal: true,
                uploadData: obj,
              };
            });
            closeUploadModal();
          }
        } else {
          toasterMsg(t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.SIZE_DOSENOT_MATCH'), 'danger');
          closeUploadModal();
        }
      }
    }
  };

  const togglePreview = async () => {
    setState((oldState) => ({
      ...oldState,
      uploadModal: false,
    }));

    await uploadExcelDocument();
  };

  const handleCheckboxChange = () => {
    setState((oldState) => ({
      ...oldState,
      isChecked: !state?.isChecked,
    }));
  };

  const handleNoButtonClick = async () => {
    setState((oldState) => ({
      ...oldState,
      AddToThePomLibrary: false,
      uploadModal: false,
    }));

    await uploadExcelDocument(false); // Close the modal
  };

  const handleYesButtonClick = async () => {
    setState((oldState) => ({
      ...oldState,
      AddToThePomLibrary: true,
      uploadModal: false,
    }));
    await uploadExcelDocument(true);
  };

  const selectDropDown = async (e) => {
    setSelectDrop({ value: e.value, label: e.label });
  };
  const placeHolder = () => {
    return selectDrop?.value;
  };

  const filterByLibrary = (option, props) => {
    const referenceCode = option?.code ? option?.code?.toLowerCase() : '';
    const bomDescription = option?.description ? option?.description?.toLowerCase() : '';
    const search = props.text.trim().toLowerCase();
    return referenceCode.includes(search) || bomDescription.includes(search);
  };

  const filterByGroup = (option, props) => {
    const referenceCode = option?.groupName ? option?.groupName?.toLowerCase() : '';

    const search = props.text.trim().toLowerCase();
    return referenceCode.includes(search);
  };

  const promiseSearch = async (inputValue) => {
    setsuggestionLoader((prev) => !prev);
    const params = {
      searchText: inputValue,
      loggedInUserId,
    };

    if (selectDrop?.value === 'Library') {
      await dispatch(action.getAllPom(params, t));
    } else {
      await dispatch(action.fetchPomGroupsWithLibrary(params));
    }
    setsuggestionLoader((prev) => !prev);
  };

  const toggleRearrangeModal = (bolSttae) => {
    if (bolSttae) {
      setState((prev) => ({
        ...prev,
        OpenReArrange: bolSttae,
        rearrangeData: gradingGroupState?.pomTableData?.map((vl, index) => {
          return { ...vl, label: vl?.code, sequence: index, name: `${vl?.code} - ${vl?.description}` };
        }),
      }));
    } else {
      setState((prev) => ({ ...prev, OpenReArrange: false, rearrangeData: [] }));
    }
  };

  const handleSaveSequence = async ({ sequence }) => {
    const sequenceMap = new Map(sequence.map((item) => [item._id, item.sequence]));
    const sortedMainArray = state?.rearrangeData?.sort((a, b) => {
      return (sequenceMap.get(a._id) || Infinity) - (sequenceMap.get(b._id) || Infinity);
    });
    updateReArrangeSequence(sortedMainArray);
    toggleRearrangeModal(false);
  };

  return (
    <Container className="grading-group-edit" fluid>
      <div className="product-care-list mt-24  mb-24 pt-list">
        <div className="filter-container position-relative" style={{ zIndex: 6 }}>
          <div className="custom-react-select import-grading" style={{ width: '75px' }}>
            <Select
              options={dropDownOptions}
              styles={customStylesGradingFilter}
              classNamePrefix="common-select"
              placeholder={placeHolder()}
              // value={selectDrop?.value}
              defaultValue={{ value: 'Library', label: <i className="icon-Library-1 library-icon-css f-24" />, title: t('TAKING_DATES.LIBRARYS') }}
              onChange={(e) => selectDropDown(e)}
            />
          </div>

          {selectDrop?.value === 'Library' && (
            <form>
              <AsyncTypeahead
                ref={typeaheadConfig}
                promptText={t('POM_GROUP.NO_PRODUCT_FOUND')}
                placeholder={t('POM_GROUP.SEARCH_POM_LIBRARY')}
                isLoading={suggestionLoader}
                labelKey="code"
                className="library-input"
                filterBy={filterByLibrary}
                onSearch={(query) => promiseSearch(query)}
                useCache={false}
                options={gradingGroupState?.libraryList}
                minLength={1}
                onChange={(selected) => onAddGradingLibrary(selected)}
                id="typeheadWithLibrary"
                renderMenuItemChildren={(options) => (
                  <div className="d-flex" key={options.code}>
                    <div className="list-text">
                      {options?.code}-{options?.description}
                    </div>
                  </div>
                )}
                autoFocus
                disabled={gradingGroupState?.isView || !GradingAddEditAccess || !gradingGroupState?.applySizeRangesToHeaderText}
              />
            </form>
          )}

          {selectDrop?.value === 'Group' && (
            <form>
              <AsyncTypeahead
                ref={typeaheadConfig}
                promptText={t('POM_GROUP.NO_GROUP_FOUND')}
                placeholder={t('POM_GROUP.SEARCH_GROUP')}
                isLoading={suggestionLoader}
                labelKey="groupName"
                filterBy={filterByGroup}
                onSearch={(query) => promiseSearch(query)}
                useCache={false}
                className="library-input"
                options={gradingGroupState?.groupsList}
                minLength={1}
                id="typeheadWithLibrary"
                renderMenuItemChildren={(options) => (
                  <div className="d-flex" key={options?._id}>
                    <div className="list-text">{options?.groupName}</div>
                  </div>
                )}
                disabled={gradingGroupState?.isView || !GradingAddEditAccess}
                onChange={(selected) => onAddGradingFromLibrary(selected)}
                autoFocus
              />
            </form>
          )}

          {GradingDeleteAccess && (
            <CustomTooltip tooltipText={t('COMMON_LABEL.DELETE')}>
              <button
                aria-label={t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.DELETE_SELECTED')}
                type="button"
                className="btn btn-outline grading-btn"
                onClick={() => {
                  handleMultiDelete();
                }}
                disabled={!gradingGroupState?.selectedPOM.length || gradingGroupState?.isView || !GradingDeleteAccess}
              >
                <i className="icon-Delete f-24" />
              </button>
            </CustomTooltip>
          )}
          {GradingAddEditAccess && (
            <CustomTooltip tooltipText={t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.UPLOAD_EXCEL_POMS')}>
              <button
                type="button"
                aria-label={t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.UPLOAD_EXCEL_POMS')}
                onClick={() => uploadPomXlsx()}
                className="btn btn-outline grading-btn"
                disabled={history.location.pathname?.includes('/add')}
              >
                <i className="icon-Upload-1 f-24" />
              </button>
            </CustomTooltip>
          )}
          <CustomTooltip tooltipText={t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.DOWNLOAD_SAMPLE_FILE')}>
            <button
              type="button"
              aria-label={t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.DOWNLOAD_SAMPLE_FILE')}
              onClick={() => downloadSampleFile()}
              className="btn btn-outline grading-btn"
              disabled={gradingGroupState?.isView || !gradingGroupState?.applySizeRangesToHeaderText}
            >
              <i className="icon-Download f-24" />
            </button>
          </CustomTooltip>
          <CustomTooltip tooltipText={t('COSTING_STAGE_MASTER.REARRANGE')}>
            <button
              type="button"
              className="btn btn-outline grading-btn"
              aria-label="Rearrange"
              onClick={() => toggleRearrangeModal(true)}
              disabled={gradingGroupState?.isView || !gradingGroupState?.pomTableData?.length}
            >
              <span className="icon-Rearrange text-grey  f-24" />
            </button>
          </CustomTooltip>
          <div className="ml-auto d-flex align-items-center">
            <p className="m-0 f-16 text-bold">{t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.MEASUREMENT_UNIT')}: &nbsp;&nbsp;</p>

            <div className={`common-react-select mb-0 uom-select ${isMenuOpen ? 'z-index-upgrade' : ''}`}>
              <Select
                className="text-dark common-select"
                placeholder={t('POMS.GRADING_GROUP.POM_LIBRARY_TABLE.UOM')}
                name="sizeType"
                type="text"
                menuPlacement="auto"
                menuPosition="fixed"
                maxMenuHeight={100}
                classNamePrefix="common-select"
                styles={SelectBoxStyles}
                isDisabled={gradingGroupState?.isView}
                value={UnitOfMeasure?.find((unit) => unit?._id === gradingGroupState?.conversionTypeId)}
                options={state?.dropDownOption}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                onChange={(selected) => handleSelectedSize(selected)}
                onMenuOpen={() => setIsMenuOpen(true)}
                onMenuClose={() => setIsMenuOpen(false)}
              />
            </div>
          </div>
        </div>
      </div>
      {gradingGroupState?.importModal && (
        <ImportModal
          showUploadModal={gradingGroupState?.importModal}
          closeUploadModal={closeUploadModal}
          docRef={docRef}
          addDocument={addDocument}
          loader={false}
        />
      )}
      {gradingGroupState?.isErrorShow && (
        <ErrorLogModal show={gradingGroupState?.isErrorShow} log={gradingGroupState?.errorLog} handleClose={() => handleCloseError()} />
      )}
      {state.uploadModal && (
        <ConfirmationModalForUpload
          onOpen={state.uploadModal}
          toggle={togglePreview}
          data={state}
          handleCheckboxChange={handleCheckboxChange}
          handleNoButtonClick={handleNoButtonClick}
          handleYesButtonClick={handleYesButtonClick}
        />
      )}
      {state.OpenReArrange && (
        <DragDrogRearrange
          forSystemMaster
          isShow={state.OpenReArrange}
          saveSequence={handleSaveSequence}
          isToggle={() => toggleRearrangeModal(false)}
          itemList={state?.rearrangeData}
        />
      )}
      {showMultiDeleteConfirm && (
        <ConfirmationPopup
          onOpen={showMultiDeleteConfirm}
          onConfirm={confirmMultiDelete}
          toggle={closeMultiDeleteConfirm}
          title={t('POMS.GRADING_GROUP.DELETE_POM_CONFIRM.TITLE_MULTI')}
          message={t('POMS.GRADING_GROUP.DELETE_POM_CONFIRM.MESSAGE_MULTI', { count: gradingGroupState?.selectedPOM?.length || 0 })}
          secondMessage={t('POMS.GRADING_GROUP.DELETE_POM_CONFIRM.SECOND_MESSAGE')}
          loading={false}
        />
      )}
    </Container>
  );
}

export default PomLibraryTable;
